import { render, staticRenderFns } from "./TopBack.vue?vue&type=template&id=43c69869&scoped=true&"
import script from "./TopBack.vue?vue&type=script&lang=js&"
export * from "./TopBack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c69869",
  null
  
)

export default component.exports